import * as React from "react";

import { Header } from "./header/Header";
import { Sidebar } from "./sidebar/Sidebar";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import FontLoader from "../utils/fonts/FontLoader";
import font from "../utils/fonts/raleway/static/Raleway-Medium.ttf";
import { ReactNode } from "react";
import { useSidebar } from "../contexts/SidebarContext";

type Props = {
  title?: string;
  children?: ReactNode;
};

export const Layout: React.FC<Props> = ({ children, title = "" }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { isCollapsed } = useSidebar();
  //Handle Menu menu opening and closing
  const handleMobileMenuClick = () => {
    setMobileOpen(!mobileOpen);
  };

  const sidebar = React.useMemo(
    () => (
      <Sidebar
        handleDrawerToggle={handleMobileMenuClick}
        mobileOpen={mobileOpen}
        isCollapsed={isCollapsed}
      />
    ),
    [mobileOpen, isCollapsed]
  );

  return (
    <div>
      {/*<Header>*/}
      {/*  <title>{title}</title>*/}
      {/*  <meta charSet="utf-8" />*/}
      {/*  <meta name="viewport" content="initial-scale=1.0, width=device-width" />*/}
      {/*  <link*/}
      {/*    rel="stylesheet"*/}
      {/*    href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"*/}
      {/*  />*/}
      {/*</Header>*/}
      <Header title={title} />
      <FontLoader fontFamily="Poppins" fontUrl={font} />
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Header handleDrawerToggle={handleMobileMenuClick} title={title} />
        {sidebar}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 1.25,
            bgcolor: "#F5F5F5",
            fontFamily: "Poppins",
            overflowX: "hidden",
          }}
        >
          <Toolbar />
          <div
            className={`${isCollapsed ? "w-full px-8" : "container"} m-auto`}
          >
            {children}
          </div>
        </Box>
      </Box>
    </div>
  );
};
